var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "退货邀请客户自助下单",
        visible: _vm.dialogVisible,
        "before-close": _vm.closeDialog,
        width: "750px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticStyle: { "text-align": "left", padding: "0px 0px 10px 0px" } },
        [
          _c(
            "el-alert",
            {
              staticClass: "alert",
              staticStyle: { width: "700px" },
              attrs: {
                title: "",
                type: "warning",
                "show-icon": "",
                closable: false,
              },
            },
            [
              _c("div", [
                _vm._v(
                  "1、客户扫码下单后，需您确认审核通过才会下单成功，也可设置自动审核"
                ),
              ]),
              _c("div", [
                _vm._v("2、更改退货收件地址后，会生成新二维码，原二维码会失效"),
              ]),
              _c("div", [
                _vm._v(
                  "3、更改自动审核开关、用户下单配置和上门取件时间类型后，会生成新二维码，原二维码为原有设置，新二维码为新设置"
                ),
              ]),
              _c("div", [_vm._v("4、重置二维码后，历史生成的二维码会失效")]),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "y-p-r",
          attrs: { model: _vm.form, "label-width": "10px" },
        },
        [
          _c("div", { staticClass: "big-title y-p-r" }, [
            _c("span", [_vm._v("自动通过审核")]),
          ]),
          _c("el-form-item", { attrs: { label: "", prop: "autoAudit" } }, [
            _c(
              "div",
              { staticClass: "y-f y-f-a y-mt-10" },
              [
                _c("el-switch", {
                  model: {
                    value: _vm.form.autoAudit,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "autoAudit", $$v)
                    },
                    expression: "form.autoAudit",
                  },
                }),
                _c("span", { staticClass: "y-ml-10" }, [
                  _vm._v("开启后，客户扫码下单后，系统自动审核通过并下单成功"),
                ]),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "big-title y-p-r" }, [
            _c("span", [_vm._v("退货收件地址")]),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "", prop: "addressId" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "y-w-600 y-mt-15",
                  attrs: {
                    "popper-append-to-body": false,
                    "popper-class": "y-w-600",
                    filterable: "",
                    "no-match-text": " ",
                    placeholder: "请选择退货收件地址",
                  },
                  model: {
                    value: _vm.form.addressId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "addressId", $$v)
                    },
                    expression: "form.addressId",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _c(
                "span",
                {
                  staticClass: "systemColor y-ml-10 y-c-p",
                  on: {
                    click: function ($event) {
                      _vm.showAddReciverInfo = true
                    },
                  },
                },
                [_vm._v("新增地址")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "big-title y-p-r" }, [
            _c("span", [_vm._v("用户下单配置")]),
          ]),
          _c("el-form-item", { attrs: { label: "", prop: "originalOrder" } }, [
            _c(
              "div",
              { staticClass: "y-f y-f-a y-c-p y-mt-15" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.form.originalOrder,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "originalOrder", $$v)
                      },
                      expression: "form.originalOrder",
                    },
                  },
                  [_vm._v("用户下单时需填写原订单号")]
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "big-title y-p-r" }, [
            _c("span", [_vm._v("上门取件时间")]),
          ]),
          _c("el-form-item", { attrs: { label: "", prop: "dayFlag" } }, [
            _c(
              "div",
              {
                staticClass: "y-f y-f-a y-c-p y-mt-15 y-fl-20",
                on: {
                  click: function ($event) {
                    _vm.form.dayFlag = "today"
                  },
                },
              },
              [
                _vm.form.dayFlag == "today"
                  ? _c("img", {
                      staticClass: "radio-icon",
                      attrs: {
                        src: require("@/assets/images/icon/radio_check_new.png"),
                      },
                    })
                  : _c("img", {
                      staticClass: "radio-icon radio-icon-uncheck",
                      attrs: {
                        src: require("@/assets/images/icon/radio_uncheck.png"),
                      },
                    }),
                _c("div", { staticClass: "y-ml-10 y-f-shrink" }, [
                  _vm._v("当日取"),
                ]),
                _c("div", { staticClass: "y-ml-10" }, [
                  _vm._v("消费者下单审核通过后，业务员联系消费者预约取件时间"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "y-f y-f-ab y-c-p y-mt-15 y-fl-20",
                on: {
                  click: function ($event) {
                    _vm.form.dayFlag = "nextDay"
                  },
                },
              },
              [
                _c("div", { staticClass: "y-f y-f-a y-mr-20" }, [
                  _vm.form.dayFlag == "nextDay"
                    ? _c("img", {
                        staticClass: "radio-icon",
                        attrs: {
                          src: require("@/assets/images/icon/radio_check_new.png"),
                        },
                      })
                    : _c("img", {
                        staticClass: "radio-icon radio-icon-uncheck",
                        attrs: {
                          src: require("@/assets/images/icon/radio_uncheck.png"),
                        },
                      }),
                  _c("div", { staticClass: "y-ml-10 y-f-shrink" }, [
                    _vm._v("定时取"),
                  ]),
                ]),
                _c("div", { staticClass: "align-self" }, [
                  _vm._v(
                    "消费者下单审核通过后，为消费者选择的取件时间，若审核时已过预约取件开始时间，将自动调整为审核时间后近2小时"
                  ),
                ]),
              ]
            ),
          ]),
          _vm.form.qrUrl
            ? _c(
                "div",
                { staticClass: "big-title y-p-r y-f y-f-js" },
                [
                  _c("span", [_vm._v("自助下单二维码")]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "",
                        prop: "qrUrl",
                        "label-width": "184px",
                      },
                    },
                    [
                      _c("div", { staticClass: "y-mt-10" }, [
                        _c(
                          "div",
                          { staticClass: "qr-container y-p-r" },
                          [
                            _c("img", {
                              staticClass: "qrbg",
                              attrs: {
                                src: require("@/assets/images/icon/qrcode-border@2x.png"),
                              },
                            }),
                            _vm.isRefreshQrCode
                              ? _c("vue-qr", {
                                  staticClass: "custom-qr",
                                  attrs: {
                                    "logo-src": _vm.logoSrc,
                                    text: _vm.form.qrUrl,
                                    size: 120,
                                    margin: 8,
                                    logoMargin: 4,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "y-mt-20" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "y-ml-10 y-w-100",
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadQRCode()
                                  },
                                },
                              },
                              [_vm._v("下载二维码")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "y-ml-190 y-fc-systemcolor y-c-p",
                                attrs: { plain: "" },
                                on: { click: _vm.updateInvitedCode },
                              },
                              [_vm._v("重置二维码")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "download-box" }, [
                    _vm.form.qrUrl
                      ? _c(
                          "div",
                          {
                            ref: "imgRef",
                            staticClass: "qr-container-saveImg y-p-r",
                          },
                          [
                            _c("img", {
                              staticClass: "qrbg",
                              attrs: {
                                src: require("@/assets/images/icon/qrcode-border@2x.png"),
                              },
                            }),
                            _vm.isRefreshQrCode
                              ? _c("vue-qr", {
                                  staticClass: "custom-qr",
                                  attrs: {
                                    "logo-src": _vm.logoSrc,
                                    text: _vm.form.qrUrl,
                                    size: 240,
                                    margin: 8,
                                    logoMargin: 4,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("reciverInfo", {
        attrs: { value: _vm.showAddReciverInfo, isNotShowCompany: true },
        on: { close: _vm.closeReciverDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }